module.exports = __webpack_public_path__ + "img/youtube.095897ea.svg";